/**
 * The Header is a component that has space for two calls to action.
 * The CTA situated on the left hand side is reserved for the Back button.
 * The CTA on the right is allowed to be a React component.
 * Since we'd like to keep React out of viewstate, we need to pass a slug to the Header container.
 */
export const HEADER_CTA_TYPES = {
  ADVANCED_SETTINGS: 'ADVANCED_SETTINGS',
} as const;
